import moment from "moment";

export const dateTimeFormat = {
  yyyymmdd: 'yyyy-MM-dd',
  yyyymmddhhmm: 'yyyy-MM-dd hh:mms',
  yyyymmddhhmmss: 'yyyy-MM-dd hh:mm:ss',
  hhmm: 'hh:mm',
  momentYYYYMMDD: 'YYYY-MM-DD',
  momentYYYYMMDDhhmmss: 'YYYY-MM-DD HH:mm:ss',
  momentYYYYMMDDhhmm: 'YYYY-MM-DD HH:mm',
  momenthhmm: 'HH:mm',
};

export const configDateTimePicker = {
  enableTime: true,
  enableSeconds: true,
  noCalendar: true
};
export const configDatePicker = {
  wrap: true, // set wrap to true only when using 'input-group'
  altFormat: 'M j, Y',
  altInput: true,
  dateFormat: 'Y-m-d',
};


export function excelDateToJSDateFormat(serial) {
  let utc_days  = Math.floor(serial - 25569);
  let utc_value = utc_days * 86400;
  let date_info = new Date(utc_value * 1000);

  let fractional_day = serial - Math.floor(serial) + 0.0000001;

  let total_seconds = Math.floor(86400 * fractional_day);

  let seconds = total_seconds % 60;

  total_seconds -= seconds;

  let hours = Math.floor(total_seconds / (60 * 60));
  let minutes = Math.floor(total_seconds / 60) % 60;

  let formatDate = new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);

  if(moment(formatDate).isValid()){
    return moment(formatDate).format(dateTimeFormat.momentYYYYMMDDhhmmss);
  }else{
    return serial;
  }
}
